// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3jHve","label":"CategoryService_label__1Cewy","location":"CategoryService_location__3LWev"};